import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {PrivateWhiteboardService} from '@app/modules/whiteboard/services/private-whiteboard.service';

@Component({
  selector: 'app-private-whiteboard',
  templateUrl: './private-whiteboard.component.html',
  styleUrls: ['./private-whiteboard.component.css']
})
export class PrivateWhiteboardComponent implements OnInit {

  constructor(
    private privateWhiteboardService: PrivateWhiteboardService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    this.changeDetectorRef.detach();
    this.privateWhiteboardService.init('privateWhiteboard', 'privateWhiteboardWrapper', 'private_');
  }
}
